export default () => ({
  items: [],
});
